import React, { useState ,useEffect} from "react";
import { Grid, Card, Tabs, Tab, Box, TextField, Button, Backdrop, CircularProgress, Tooltip } from "@mui/material";
import { Edit } from '@mui/icons-material'; // Import Material-UI Edit Icon
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { url ,fileUploadUrl} from "../../constant";

function CtaSectionDashboard() {
  const [tab, setTab] = useState(0);
  const [ctaHeading, setCtaHeading] = useState("");
  const [ctas, setCtas] = useState([
    {
      id: 1,
      title: "Pronto a iniziare?",
      description: "Unisciti a noi oggi e trasforma il modo in cui gestisci bandi.",
      button_text: "Inizia ora"
    },
    {
      id: 2,
      title: "Scopri di più",
      description: "Esplora tutte le funzionalità della piattaforma.",
      button_text: "Scopri"
    }
  ]);
  const [formState, setFormState] = useState({ title: "", description: "", button_text: "", button_link: "" });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // Toggle edit mode for CTA heading
  const [isEditingHeading, setIsEditingHeading] = useState(false);

  useEffect(() => {
    // fetchHeading();
    fetchCtaSections();
  }, []);

  const fetchCtaSections = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${url}auth/get-cta-sections`);
      if (!res.ok) throw new Error(`Error: ${res.status}`);

      const data = await res.json();

      console.log("get-cta-sections", data);

      setCtas(data);
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };

  // Heading fetch karne ke liye
  const fetchHeading = () => {
    fetch(`${url}auth/cta-heading`)  // backend ka endpoint
      .then((res) => res.json())
      .then((data) => {

        setCtaHeading(data.data || "Default Heading");
        console.log("cta-heading",data);

      })
      .catch((err) => console.error("Failed to fetch heading:", err));
  };

  const handleSaveHeading = () => {
    // Save the new heading to the backend
    fetch(`${url}auth/cta-heading`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ title: ctaHeading }),
    })
      .then((res) => res.json())
      .then((data) => {
        // setCtaHeading(data.data); // Update the heading in state
        fetchHeading();
        setIsEditingHeading(false); // Exit edit mode
      })
      .catch((err) => {
        console.log("Failed to save heading:", err);
      });
  };


  const handleEditHeading = () => {
    setIsEditingHeading(true);
  };

  const handleCancelEdit = () => {
    fetchHeading();
    setIsEditingHeading(false); // Close the edit mode without saving
  };

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "title", accessor: "title" },
    // { Header: "description", accessor: "description" },
    {
      Header: "Description",
      accessor: "description",
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 350,
            }}
          >
            {value}
          </div>
        </Tooltip>
      )
    },
    { Header: "Button Text", accessor: "button_text" },
    { Header: "Button link", accessor: "button_link" },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (

        <>

          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }}
            onClick={() => {
              setFormState({
                title: row.original.title,
                description: row.original.description,
                button_text: row.original.button_text,
                button_link: row.original.button_link
              });
              setEditId(row.original.id);
              setIsEditingHeading(false);
              setTab(1);
              
            }}
          >
            Modifica
          </Button>

          {/* Delete Button */}
          {/* <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => handleDelete(row.original.id)}
            sx={{
              fontWeight: 'bold',
              padding: '8px 16px',
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': { backgroundColor: '#c62828' },
              marginLeft: 2
            }}

          >
          
            Cancella
          </Button> */}

        </>

      )
    }
  ];

  const rows = ctas.map(item => ({ ...item, actions: "" }));

  // const handleSave = () => {
  //   setFormLoading(true);
  //   setTimeout(() => {
  //     if (editId) {
  //       setCtas(prev => prev.map(item => item.id === editId ? { id: editId, ...formState } : item));
  //     } else {
  //       const nextId = ctas.length + 1;
  //       setCtas(prev => [...prev, { id: nextId, ...formState }]);
  //     }
  //     setFormState({ title: "", description: "", button_text: "" });
  //     setEditId(null);
  //     setTab(0);
  //     setFormLoading(false);
  //   }, 500);
  // };


  const handleSave = async () => {
    setFormLoading(true);

    try {
      const endpoint = editId
        ? `${url}auth/update-cta-section/${editId}`
        : `${url}auth/create-cta-section`;

      const method = "POST";

      const res = await fetch(endpoint, {
        method,
        headers: {
          "Content-Type": "application/json",
          // Include Authorization header if needed
          // "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(formState)
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || "Errore salvataggio CTA");
      }

      const result = await res.json();

      // Refresh the list
      fetchCtaSections();

      // Reset form
      setFormState({ title: "", description: "", button_text: "" , button_link: "" });
      setEditId(null);
      setTab(0);
    } catch (error) {
      console.error("Errore nel salvataggio:", error.message);
      alert("Errore: " + error.message);
    } finally {
      setFormLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler cancellare questa CTA?")) return;

    setLoading(true);
    try {
      const res = await fetch(`${url}auth/delete-cta-section/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          // Include Authorization header if required
          // "Authorization": `Bearer ${token}`
        },
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Errore nella cancellazione");
      }

      // Optionally show a success message here
      // Refresh the list
      fetchCtaSections();
    } catch (error) {
      console.error("Errore durante la cancellazione:", error.message);
      alert("Errore: " + error.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Backdrop open={loading || formLoading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="#183759"
                borderRadius="lg"
                // coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Call‑to‑Action Section
                </MDTypography>
              </MDBox>


              {/* CTA Heading Section: Editable */}
              <MDBox 
              // pt={3} 
              // mb={3} 
              px={2}
              >
                <Grid container>
                  <Grid item xs={12} sm={8} md={6}>
                    <Grid container alignItems="center">
                      {/* Left: Heading */}

                      { // if this section use so Not ! operator use
                        isEditingHeading &&
                        (
                          <>

                            <Grid item xs={4} >
                              <MDTypography
                                variant="h5"
                                sx={{
                                  fontWeight: 'bold',
                                  color: "#183759",  // Adjust text color
                                  fontSize: "24px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {ctaHeading}
                              </MDTypography>
                            </Grid>

                          </>
                        )
                      }


                      {/* Right: Edit Icon or Button */}

                      { // if this section use so Not ! operator use
                        isEditingHeading && (
                          <>
                            <Grid item xs={4}>
                              <Button
                                variant="outlined"
                                onClick={handleEditHeading}
                                sx={{
                                  borderRadius: "50%",
                                  width: "40px",
                                  height: "40px",
                                  padding: "0",
                                  minWidth: "auto",
                                  // backgroundColor: "#f1f1f1",
                                  color: "#183759",
                                  "&:hover": {
                                    backgroundColor: "#f1f1f1", // Keep the background color same on hover
                                    border: "1px solid #183759",  // Keep the border color the same on hover
                                  },
                                  border: "1px solid #183759",  // Ensure border color stays consistent
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Edit sx={{ fontSize: 16 }} />  {/* Material-UI Edit Icon */}
                              </Button>
                            </Grid>

                          </>
                        )
                      }


                    </Grid>

                    {/* Edit Mode */}
                    {isEditingHeading && (
                      <>
                        <TextField
                          label="Edit CTA Heading"
                          fullWidth
                          value={ctaHeading}
                          onChange={(e) => setCtaHeading(e.target.value)}
                          sx={{ mb: 2 }}
                        />
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={handleSaveHeading}
                              sx={{
                                backgroundColor: "#183759",
                                color: "#fff",
                                "&:hover": { backgroundColor: "#204b80" },
                              }}
                            >
                              Save Heading
                            </Button>
                          </Grid>
                          <Grid item xs={6}>
                            <Button
                              variant="outlined"
                              fullWidth
                              onClick={handleCancelEdit}
                              sx={{
                                backgroundColor: "#f1f1f1",
                                color: "#183759",
                                border: "1px solid #183759",  // Ensure border color stays consistent
                                "&:hover": {
                                  backgroundColor: "#f1f1f1", // Keep the background color same on hover
                                  border: "1px solid #183759",  // Keep the border color the same on hover
                                },
                              }}
                            >
                              Cancel
                            </Button>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </MDBox>


              <Tabs value={tab} onChange={(e, val) => setTab(val)} variant="fullWidth">
                <Tab label="Elenco CTA" />
                {/* <Tab label={editId ? "Modifica CTA" : ""} /> */}
                {editId && <Tab label="Modifica CTA" />}
              </Tabs>



              {tab === 0 && (
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 10 }}
                    showTotalEntries={false}
                    noEndBorder
                    currentPageIndex={currentPageIndex}
                    setCurrentPageIndex = {setCurrentPageIndex}
                  />
                </MDBox>
              )}

              {tab === 1 && (
                <MDBox pt={3} px={2}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>

                      

                      <TextField
                        label="Title"
                        fullWidth
                        value={formState.title}
                        onChange={e => setFormState({ ...formState, title: e.target.value })}
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        label="Description"
                        fullWidth
                        multiline
                        value={formState.description}
                        onChange={e => setFormState({ ...formState, description: e.target.value })}
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        label="Button Text"
                        fullWidth
                        value={formState.button_text}
                        onChange={e => setFormState({ ...formState, button_text: e.target.value })}
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        label="Button Link" // ✅ New field
                        fullWidth
                        value={formState.button_link}
                        onChange={e => setFormState({ ...formState, button_link: e.target.value })}
                        sx={{ mb: 2 }}
                      />

                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleSave}
                        sx={{ mb:5, backgroundColor: "#183759", color:"#fff", "&:hover": { backgroundColor: "#204b80" } }}
                      >
                        {editId ? "Aggiorna" : "Salva"}
                      </Button>
                    </Grid>
                  </Grid>
                </MDBox>
              )}

             

            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default CtaSectionDashboard;
